import React, { Component } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import Swal from "sweetalert2";
import CreateCompany from "./CreateCompany";
import { currentDateAndTime } from "../../Constants/Constants";
import PageTitle from "../../Components/PageTitle";
import { NavLink } from "react-router-dom";
import CompanyStatutory from "./CompanyStatutory";

class CompanyOnboard extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      selectedInfoTab: "1",
      guest_employee_mobile_number: "",
      company_id: "",
      companyInfo: {},
      encryptedData: "",
      isPage404: false,
      loadingList: false,
      msg: "",
    };
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const encryptedData = queryParams.get("data");
    const id = queryParams.get('id');
    this.setState({ company_id: id || false});
    // if (encryptedData) {
    //   this.setState(
    //     {
    //       loadingList:true,
    //       encryptedData:encryptedData,
    //       guest_employee_mobile_number: "",
    //       company_id: "",
    //       isPage404: false,
    //     },
    //     () => {
    //       this.getDecryptedData();
    //     }
    //   );
    // } else if (!encryptedData) {
    //   this.setState({
    //     encryptedData:'',
    //     guest_employee_mobile_number: "",
    //     company_id: "",
    //     isPage404: "Opps...! Something went wrong!",
    //   });
    // }
  }
//   GetList = () => {
//     const { apiURL, apiHeaderJSON } = this.context;
//     const headers = apiHeaderJSON;
//     console.log(this.state.company_id,this.state.guest_employee_mobile_number);
//     axios
//       .get(`${apiURL}Home/EmployeeCollectedData`, {
//         params: {
//           // guest_employee_id:"10",
//           company_id: this.state.company_id,
//           guest_employee_mobile_number: this.state.guest_employee_mobile_number,
//           date: currentDateAndTime(),
//         },
//         headers,
//       })
//       .then((response) => {
//         const { employee_data , success, message,data_collection_link_status } = response.data;
//         if (success === true) {
//           console.log("Personal Details - GetInfo", employee_data);
//           this.setState({
//             isPage404: false,
//             loadingList: false,
//           });
//         } else {
//           if (data_collection_link_status === "4") {
//             this.setState({ isPage404: data_collection_link_status, msg: message,loadingList: false, });
//           } 
//           else if(data_collection_link_status === "3") {
//             this.setState({
//               isPage404: data_collection_link_status,
//               msg: message,
//               loadingList: false,
//             });
//           } else {
//             this.setState({
//               isPage404: message || "Opps...! Something went wrong!",
//               msg:"Opps...! Something went wrong!",
//               loadingList: false,
//             });
//           }
//         }
//       })
//       .catch((error) => {
//         this.setState({
//           isPage404:"Opps...! Something went wrong!",
//           msg:"Opps...! Something went wrong!",
//           loadingList: false,
//         });
//         Swal.fire({
//           title: `<strong>${"Failed"}</strong>`,
//           text: "Opps...! Something went wrong!",
//           icon: "error",
//           showConfirmButton: true,
//           allowOutsideClick: false,
//         });
//         console.error("Error uploading file:", error);
//       });
//   };
//   getDecryptedData = () => {
//     const { apiURL, apiHeaderJSON } = this.context;
//     const headers = apiHeaderJSON;
//     const fromData={
//         encryptedData:this.state.encryptedData
//     }
//     axios
//         .post(`${apiURL}User/DecryptData`,fromData, {headers})
//         .then((response) => {
//             var data = response.data;
//             console.log('DecryptData',data);
//             if (response.data.success === true) {
//                 let temp= parseQueryString(data?.decryptedData);
//                 console.log("tenp",temp);
//                 this.setState({
//                   company_id:temp?.c_id,
//                   guest_employee_mobile_number:temp?.mo_n,
//                 },()=>{
//                   this.GetList();
//                 });
//             } else {
//               this.setState({
//                 isPage404: "Opps...! Something went wrong!",
//                 msg:"Opps...! Something went wrong!",
//                 loadingList: false,
//               });
//             }
//         }).catch((error)=>{
//           this.setState({
//             isPage404:"Opps...! Something went wrong!",
//             msg:"Opps...! Something went wrong!",
//             loadingList: false,
//           });
//             Swal.fire({
//                 title: `<strong>Failed</strong>`,
//                 text: "Opps...! Something went wrong !!",
//                 icon: 'error',
//                 showConfirmButton: true,
//                 allowOutsideClick: false
//             })
//         });
// };

  handleSubmit = (row, idx) => {
    const formData = {};
    const { apiHeaderFile, apiURL } = this.context;
    const headers = apiHeaderFile;

    Swal.fire({
      title: "Are you sure?",
      text: "You want to submit all details!",
      icon: "warning",
      showCancelButton: true,
      // confirmButtonColor: "#3085d6",
      // cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Submit!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ loadingFinalSubmit: true });
        axios
          .post(`${apiURL}Home/FinalDetailSubmission`, formData, {
            params: {
              date: currentDateAndTime(),
              company_id: this.state.company_id,
              guest_employee_mobile_number:
                this.state.guest_employee_mobile_number,
            },
            headers,
          })
          .then((response) => {
            const data = response.data;
            if (response.data.success === true) {
              console.log("FinalDetailSubmission =>",data)
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              });

              this.setState({ loadingFinalSubmit: false }, () => {
                this.GetList();
              });
            } else {
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Set your state here
                  if(data?.missing_step){
                    this.setState({ selectedInfoTab: `${data?.missing_step}` });
                  }
                  
                }
              });
              this.setState({ loadingFinalSubmit: false, });
            }
          })
          .catch((error) => {
            this.setState({ loadingFinalSubmit: false });
            Swal.fire({
              title: `<strong>${"Failed"}</strong>`,
              text: "Opps...! Something went wrong!",
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
            console.error("Error uploading file:", error);
          });
      }
    });
  };

  renderComponent = () => {
    if (this.state.selectedInfoTab === "1") {
      return <CreateCompany company_id={this.state.company_id} />;
    } 
    else if (this.state.selectedInfoTab === "2") {
      return <CompanyStatutory company_id={this.state.company_id} />;
    } 
  };

  render() {
    const { isPage404,msg, loadingList } = this.state;
    return (
      !loadingList?
        (<div class="main-content">
            {/* <ViewOnlyHeader url={this.state.companyInfo?.logo_url} name={this.state.companyInfo?.company_name} /> */}
            <div className="page-content">
              <div className="container-fluid mt-4">
                <PageTitle title={`Company Onboard`} primary={`Home`} />
                  {/* <h4 className="font-semibold ">Candidate Details</h4> */}
                
                  <div className="card">
                    <div className="card-header bg-white align-items-center d-flex">
                          <h4 className="card-title mb-0 flex-grow-1">
                              Company Onboarding Form
                          </h4>
                          <NavLink className="btn btn-success btn-sm" 
                            to={`/CompanyList`}>
                              <i className="bx ri-arrow-left-circle-line label-icon align-middle fs-4 " />
                          </NavLink>
                      </div>
                    <div style={{ minHeight: "29rem" }} className="card-body pt-0">
                      <div className="card-header">
                        <ul className="nav nav-tabs-custom rounded card-header-tabs border-bottom-0 cursorPointer" role="tablist ">
                          {[
                            "Basic Details",
                            "Statutory Details",
                          ].map((tab,idx) => (
                            <li className="nav-item " role="presentation" key={tab}>
                              <p
                                className={`nav-link mb-0 pb-3 ${this.state.selectedInfoTab === `${idx+1}` ? "active" : ""}`}
                                onClick={() =>this.setState({ selectedInfoTab: `${idx+1}` })}
                              >
                                {tab.replace(/([A-Z])/g, " $1").trim()}
                              </p>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 mt-1">
                            <>
                              <div className="tab-content">
                                  {this.renderComponent()}
                              </div>
                            </>
                        </div>
                      </div>
                    </div>
                    <div className="px-4 d-flex justify-content-end align-items-center">
                        {!this.state.loadingFinalSubmit ? (
                        this.state.selectedInfoTab === "6" ? (
                            <button
                            type="button"
                            onClick={this.handleSubmit}
                            className="btn btn-success btn-label waves-effect right waves-light"
                            >
                            <i className="bx bx-save label-icon align-middle fs-16 ms-2" />{" "}
                            Submit
                            </button>
                        ) : null
                        ) : (
                        <button className="btn btn-success btn-load">
                            <span className="d-flex align-items-center">
                            <span
                                className="spinner-border flex-shrink-0"
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </span>
                            <span className="flex-grow-1 ms-2">Loading...</span>
                            </span>
                        </button>
                        )}
                    </div>
                  </div>
              </div>
            </div>
        </div>): 
        (<div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
            <div className="text-center">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            </div>
        </div>)
    )
  }
}

export default CompanyOnboard;
